import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@fry/lib/guards';
import { SYSTEM_ROLE_ID } from '@fry/lib/roles/roles.system';

import { GeneralListComponent } from './general-list/general.list.component';
import { GeneralListResolver } from './general-list/general.list.resolver';
import { GeneralModelResolver } from './general.model.resolver';


const routes: Routes = [
  {
    path: 'general',
    canActivate: [
      AuthGuard
    ],
    data: {
      requiredRole: SYSTEM_ROLE_ID.ADMIN,
    },
    children: [
     {
        path: ':type',
        component: GeneralListComponent,
        resolve: {
          data: GeneralListResolver
        },
        runGuardsAndResolvers: 'always'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    GeneralListResolver,
    GeneralModelResolver,
  ]
})
export class GeneralRoutingModule { }
